let sendEmailAPI = {
	sendEmail: (email, content, server) => {
		return new Promise((resolve, reject) => {
			let body = JSON.stringify({
				toEmail: email.to,
				fromEmail: email.from,
				subject: content.subject,
				message: content.message,
			});
			fetch(`${server}/sendMail`, {
				method: 'post',
				body: body,
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then(res => {
					return res.json();
				})
				.then(status => {
					resolve(status);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
};
export default sendEmailAPI;
